/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneCancelSubscription as ResolvedStandaloneCancelSubscription } from 'base/components/standalone/CancelSubscription';

export const CancelSubscription: typeof ResolvedStandaloneCancelSubscription = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneCancelSubscription {...props} />
        </ErrorBoundary>
    );
});

export type CancelSubscriptionProps = PropsFromComponent<typeof CancelSubscription>;

/** @deprecated Use slot architecture instead */
export const CancelSubscriptionWith = (extras: DynamicStandaloneExtras): typeof CancelSubscription => {
    return function CancelSubscription(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'CancelSubscription');
        return <ResolvedStandaloneCancelSubscription {...mergeProps({ options: { theme } }, props)} />;
    }
}